import './radioCard.scss';

import { forwardRef, ReactNode, useState } from 'react';

import { RadioCardProps } from '../RadioCardGroup/types/RadioCardProps';

export const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>(
  ({ title, subtitle, image, loading, ...props }, ref): ReactNode => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const className = [
      'radio-card',
      props.checked && 'radio-selected',
      loading && 'loading',
      props.className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <label className={className}>
        <div>
          {(loading || (image && !imageLoaded)) && (
            <div className="image-loading" />
          )}
          {!loading && image && (
            <img
              alt={title}
              className={!imageLoaded ? 'hidden' : undefined}
              src={image}
              onLoad={(): void => {
                setImageLoaded(true);
              }}
            />
          )}
          <div>
            <span className="radio-card-title">{title}</span>
            <span className="radio-card-subtitle">{subtitle}</span>
          </div>
        </div>
        <div>
          <input
            {...props}
            disabled={loading}
            ref={ref}
            role="radio"
            type="radio"
          />
          <span />
        </div>
      </label>
    );
  },
);
